import { render, staticRenderFns } from "./WAddWorkPartnerForm.vue?vue&type=template&id=5487626c&"
import script from "./WAddWorkPartnerForm.vue?vue&type=script&lang=js&"
export * from "./WAddWorkPartnerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports